import React from "react";

const CoverBlock = ({ siteSettings }) => {
    const calendlyUrl = siteSettings?.calendlyUrl || '#';
    const line1 = siteSettings?.heroLine1 || 'Subscription based';
    const line2 = siteSettings?.heroLine2 || 'Design agency';

    return (
        <div className="intro">
            <div className="row">
                <div className="title">
                    <div className="d-block d-lg-flex justify-content-lg-between w-100">
                        <div>
                            <h1>{line1}</h1>
                            <h1>{line2}</h1>
                        </div>
                        <div>
                            <a href={calendlyUrl} target="_blank" rel="noreferrer" className="d-none d-lg-block"><h1>Let's chat</h1></a>
                            <a href="#pricing" className="d-none d-lg-block"><h1>SEE PRICING</h1></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoverBlock;
